import { createContext } from 'react';

const ItemsContext = createContext({
	cart: {}, setCart: () => {},
	busy: false, setBusy: () => {},
});

export default ItemsContext;
